import { FaEnvelope, FaWhatsapp } from "react-icons/fa";
import { Link } from 'react-router-dom';

import ombudsmanBg from './ombudsman.png';

export default function Ouvidoria() {
  return (
    <section id="ombudsman" className="w-full">
      <div className="flex flex-col lg:flex-row">
        {/* Imagem de fundo (estática) */}
        <div
          className="w-full min-h-full bg-no-repeat bg-left bg-contain bg-fixed py-20"
          style={{ backgroundImage: `url(${ombudsmanBg})` }}
        ></div>

        {/* Conteúdo da Ouvidoria */}
        <div className="w-full min-h-full px-8 py-24">
          <h1
            data-aos="fade-zoom-in"
            data-aos-duration="1000"
            data-aos-delay="300"
            className="text-4xl font-normal"
          >
            Fale com nossa<br />ouvidoria
          </h1>

          <p
            data-aos="fade-zoom-in"
            data-aos-duration="1000"
            data-aos-delay="300"
            className="max-w-md mt-5 pb-6 text-base leading-7"
          >
            Estamos sempre à disposição para atender às suas necessidades e esclarecer suas dúvidas. <br />
            Nossa ouvidoria é especializada para garantir que sua experiência conosco seja a melhor possível. Sua opinião é muito importante para nós!
          </p>

          {/* Email */}
          <div
            className="flex items-center gap-3 my-2"
            data-aos="fade-zoom-in"
            data-aos-duration="1000"
            data-aos-delay="300"
          >
            <FaEnvelope size={30} className="text-gray-800" />
            <a
              href="mailto:ouvidoria@gruposeculos.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="no-underline text-gray-800 text-base hover:underline"
            >
              ouvidoria@gruposeculos.com.br
            </a>
          </div>

          {/* WhatsApp */}
          <div
            className="flex items-center gap-3 my-2"
            data-aos="fade-zoom-in"
            data-aos-duration="1000"
            data-aos-delay="300"
          >
            <FaWhatsapp size={30} className="text-gray-800" />
            <a
              href="https://wa.me/+5594999012631?text=Ol%C3%A1%2C%20estou%20vindo%20da%20p%C3%A1gina%20de%20contatos%20do%20site!"
              target="_blank"
              rel="noopener noreferrer"
              className="no-underline text-gray-800 text-base hover:underline"
            >
              (94) 99901-2631
            </a>
          </div>

          {/* Botão */}
          <div
            className="mt-14 pb-20"
            data-aos="fade-zoom-in"
            data-aos-duration="1000"
            data-aos-delay="300"
          >
            <Link
              to="/ouvidoria"
              className="no-underline inline-block text-gray-800 text-base px-6 py-3 border border-gray-800 rounded-full hover:bg-gray-200 hover:text-primary transition duration-500"
            >
              Acessar ouvidoria
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
